'use strict';

import angular from 'angular';
import LoginController from './login.controller.js';

export default angular.module('georgeApp.login', [])
  .controller('LoginController', LoginController)
  .name;
